import { useUser } from "../../../contexts/UserContext";
import type { AdminSection } from "./AdminSidebar";

const SECTION_META: Record<AdminSection, { title: string; subtitle: string; icon: string }> = {
  dashboard:  { title: "Dashboard",          subtitle: "Genel bakış ve istatistikler",       icon: "ri-dashboard-3-line" },
  venues:     { title: "Mekan Yönetimi",     subtitle: "Tüm mekanları listele ve düzenle",   icon: "ri-store-2-line" },
  categories: { title: "Kategori Yönetimi", subtitle: "Kategori düzenle ve yönet",          icon: "ri-layout-grid-line" },
  users:      { title: "Kullanıcılar",       subtitle: "Üyeler ve işletme hesapları",        icon: "ri-group-line" },
  campaigns:  { title: "Kampanyalar",        subtitle: "İndirim ve kupon kampanyaları",      icon: "ri-coupon-line" },
  ads:        { title: "Reklamlar",          subtitle: "Sponsorlu içerik ve reklam yönetimi", icon: "ri-advertisement-line" },
  support:    { title: "Destek Talepleri",   subtitle: "Gelen destek talepleri",             icon: "ri-customer-service-2-line" },
};

interface AdminTopBarProps {
  section: AdminSection;
  pendingSupport: number;
}

export default function AdminTopBar({ section, pendingSupport }: AdminTopBarProps) {
  const meta = SECTION_META[section];
  const { user } = useUser();

  const initials = user?.displayName
    ? user.displayName.split(" ").map((n) => n[0] || "").join("").toUpperCase().slice(0, 2)
    : "AD";

  return (
    <header className="h-16 bg-white border-b border-stone-100 flex items-center justify-between px-6 flex-shrink-0">
      {/* Left: Page title */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-stone-100">
          <i className={`${meta.icon} text-stone-600 text-base`} />
        </div>
        <div>
          <h1 className="font-semibold text-stone-800 text-sm leading-tight">{meta.title}</h1>
          <p className="text-xs text-stone-400">{meta.subtitle}</p>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-3">
        {/* Date */}
        <span className="hidden md:block text-xs text-stone-400">
          {new Date().toLocaleDateString("tr-TR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
        </span>

        {/* Notifications */}
        <button className="relative w-9 h-9 flex items-center justify-center rounded-xl border border-stone-200 text-stone-500 hover:bg-stone-50 transition-colors cursor-pointer">
          <i className="ri-notification-3-line text-base" />
          {pendingSupport > 0 && (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-red-500" />
          )}
        </button>

        {/* Admin avatar */}
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl border border-stone-200 cursor-pointer hover:bg-stone-50 transition-colors">
          {user?.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.displayName}
              className="w-6 h-6 rounded-full object-cover object-top"
            />
          ) : (
            <div className="w-6 h-6 rounded-full bg-emerald-700 flex items-center justify-center text-white text-xs font-bold">
              {initials}
            </div>
          )}
          <span className="text-sm text-stone-700 font-medium hidden md:block">
            {user?.displayName || "Yönetici"}
          </span>
          <i className="ri-arrow-down-s-line text-stone-400 text-sm" />
        </div>
      </div>
    </header>
  );
}
